export default __webpack_public_path__ + "static/logo-39beb49c8a850f132ee0323d42f58acd.png";